import React, {
  useEffect,
  useContext,
  useState,
  useMemo,
  useReducer,
} from "react";
import { getStudyErrorSearchList } from "../../service/MasterService";
import { format, PrimaryButton } from "@fluentui/react";
import userContext from "../../context/users/UserContext";
import { QueryClient } from "react-query";
import Moment from "moment";
import "./ErrorStudy.css";
import { useTranslation } from "react-i18next";
import { DatePicker, defaultDatePickerStrings } from "@fluentui/react";
import ColumnsErrorStudy from "./ColumnsErrorStudy";
import ListView from "../../components/ListView/ListView";
import AddButton from "../../components/AddButton";
import { AuthRoutes } from "../../constants/Constants";
import { useNavigate } from "react-router-dom";
import { CSVLink } from "react-csv";

const initialState = {
  startDate: new Date(),
  endDate: new Date(),
};

const ErrorStudy = () => {
  const [filterObj, setFilterObj] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [exportCSVData, setExportCSVData] = useState([]);
  const navigate = useNavigate();
  const [searchClicked, setSearchClicked] = useState(false);
  const [t, i18n] = useTranslation();

  function camelToUnderscore(key) {
    var result = key.replace(/([A-Z])/g, " $1");
    return result.split(" ").join("_").toLowerCase();
  }

  const fetchErrorListFunction = async (
    page,
    pageSize,
    pageFilter,
    pageSortBy
  ) => {
    let sortyByDir = false;
    let sortParams = "id";
    console.log(pageSortBy);
    if (pageSortBy != undefined && pageSortBy.length > 0) {
      sortParams = pageSortBy[0].id;
      sortyByDir = pageSortBy[0].desc;
    }
    try {
      if (sortParams == t("error-study-list.error-date"))
        sortParams = "createdDate";
      const response = await getStudyErrorSearchList(
        page,
        pageSize,
        camelToUnderscore(sortParams),
        sortyByDir,
        formatDate(filterObj.startDate),
        formatDate(filterObj.endDate)
      );
      if (response.status === 200 && response.data.result === "SUCCESS") {
        if (
          response.data.data.content != null ||
          response.data.data.content != undefined
        ) {
          setExportCSVData(response.data.data.content);
          const data = {
            results: response.data.data.content,
            count: response.data.data.totalElements,
          };
          console.log(data);
          return data;
        }
      }
    } catch (e) {
      throw new Error(`API error:${e?.message}`);
    }
  };

  const startDateFunction = (event) => {
    setFilterObj({ ...filterObj, startDate: event });
  };

  const formatDate = (date) => {
    var currentDate = Moment(date).local().format("YYYY-MM-DD");
    return date == "" ? "" : currentDate;
  };

  const endDateFunction = (event) => {
    setFilterObj({ ...filterObj, endDate: event });
  };

  const clearErrorList = () => {
    setFilterObj({ ...filterObj, startDate: "", endDate: "" });
    setSearchClicked(() => !searchClicked);
  };

  const columns = ColumnsErrorStudy();

  const searchHandler = () => {
    setSearchClicked(() => !searchClicked);
  };

  return (
    <>
        <div className="rootContainer">
          <div className="startDateContainer">
            <DatePicker
              onSelectDate={startDateFunction}
              placeholder={t("error-study-list.start-date-placeholder")}
              label={t("error-study-list.start-date")}
              value={filterObj.startDate}
              ariaLabel="Select a date"
              strings={defaultDatePickerStrings}
            />
          </div>
          <div className="endDateContainer">
            <DatePicker
              value={filterObj.endDate}
              label={t("error-study-list.end-date")}
              onSelectDate={endDateFunction}
              placeholder={t("error-study-list.end-date-placeholder")}
              ariaLabel="Select a date"
              strings={defaultDatePickerStrings}
            />
          </div>

            <PrimaryButton
             text={t("table.search")}
             onClick={searchHandler}
             style={{
               marginRight: "10px",
                   marginTop: "32px"
             }}
            />

            <PrimaryButton 
            text={t("table.reset")}
            onClick={clearErrorList}
            style={{
               marginRight: "10px",
                   marginTop: "32px"
             }}
          />
          <CSVLink data={exportCSVData}>
            <PrimaryButton
              buttonType="primary"
              text={t("table.export-csv")}
              style={{
                marginRight: "10px",
                marginTop: "32px"
             }}
            />
          </CSVLink>
            
        </div>
        <ListView 
          pageHeader ={t("error-study-list.error-study")} 
          buttonsTopBar = {[]}
          fetchDataFunction = {fetchErrorListFunction}
          columns = {columns}
          widthContainer = "40%"
          filterObj = {filterObj}
          updateCurrentPage = "false"
          // heightTBody="67vh"
          handleUserClick = {()=>{}}
        />
    </>
  );
};

export default ErrorStudy;
